import { renderRecommendedProducts } from '../common/cart-drawer';
import {getVariantQuantity} from "@/utils/product";

export const changeCartItemsCount = (count, countTotal) => {
  if (countTotal !== undefined) {
    document.querySelector(
      '.header__icon--cart .icon-title'
    ).textContent = `BAG (${countTotal})`;
  }
  if (count) {
    document.querySelector('.Header__CartDot').classList.add('is-visible');
  } else {
    document.querySelector('.Header__CartDot').classList.remove('is-visible');
  }
};

export const switchCheckoutUrlOnRerender = () => {
  const country = window.countryCode;
  if (!country) return;
  document
    .getElementById('CartDrawer-Checkout')
    ?.setAttribute('href', country === 'US' ? '/checkout' : '/cart');
};

export const fetchCartContent = async () => {
  const response = await fetch('/cart.js');
  if (response.ok) {
    return response.json();
  }
  return null;
};

export const rerenderCartContent = async () => {
  const isCartPage = window.location.pathname.includes('cart');
  let cartContent = await fetch(
    `/?section_id=${isCartPage ? 'main-cart-items' : 'cart-drawer'}`,
    {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    }
  );

  cartContent = await cartContent.text();
  const mainItemsContainerSelector = isCartPage
    ? '.cart-page-items'
    : '#CartDrawer';
  const tempElement = document.createElement('div');

  tempElement.innerHTML = cartContent;
  const fetchedCartContent = tempElement.querySelector(
    mainItemsContainerSelector
  );

  if (!fetchedCartContent) return;

  const cartItems = fetchedCartContent.querySelectorAll('.cart__items--row');

  let itemsQuantityTotal = 0;
  cartItems.forEach((i) => {
    const quantity = i.querySelector('.quantity__input')?.value;
    if (!quantity) return;
    itemsQuantityTotal += +quantity;
  });
  const itemsCount = cartItems.length;

  changeCartItemsCount(itemsCount, itemsQuantityTotal);

  if (!itemsCount) return;

  const currentCartContent = document.querySelector(
    isCartPage ? '.main-cart-items-wrapper' : '.drawer'
  );
  currentCartContent.classList.remove('is-empty');
  currentCartContent.innerHTML = '';

  currentCartContent.insertAdjacentElement('beforeend', fetchedCartContent);

  if (!isCartPage) {
    renderRecommendedProducts();
  }
};

export const addItemsToCart = async (items = [], ...variants) => {
  try {
    if (!items.length) return {};
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      mode: 'same-origin',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({ items }),
    }).then((res) => res.json());

    if (response.status?.toString()?.startsWith('4')) {
      return response;
    }

    await afterAddToCart(items, variants);
    return response;
  } catch (er) {
    console.log(er);
    return er;
  }
};

export const changeCartItems = async (quantityObj, items = [], ...variants) => {
  try {
    const fetchURL = `/cart/change.js`;
    const fetchObj = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(quantityObj),
    };
    const response = await fetch(fetchURL, fetchObj).then((res) => res.json());

    if (response.status?.toString()?.startsWith('4')) {
      return response;
    }
    await afterAddToCart(items, variants);
    return response;
  } catch (er) {
    console.log(er);
    return er;
  }
};

export const formatErrorMessage = (message, maxAllowedQuantity) => {
  const messageParts = message.split('-');
  if (maxAllowedQuantity) {
    const message = messageParts[0].split('more');
    return `${message[0]}more than ${maxAllowedQuantity} ${message[1]} to the cart.`;
  }
  return `${messageParts[0]} to the cart.`;
}

export const onAddToCart = async (items = [], ...variants) => {
  try {
    // Fetch current cart data from Shopify
    const cartData = await fetch('/cart.js').then((res) => res.json());

    // Helper function to handle error message formatting
    const handleResponseMessage = async (response, itemId, currentQuantity = 0) => {
      if (response.message) {
        const { quantityAvailable } = await getVariantQuantity(itemId);
        const maxAllowedQuantity = quantityAvailable - currentQuantity;
        response.message = formatErrorMessage(response.message, maxAllowedQuantity);
      }
    };

    // If the cart is empty, add items directly
    if (!cartData?.items?.length) {
      const response = await addItemsToCart(items, ...variants);
      await handleResponseMessage(response, items[0]?.id);
      return response;
    }

    // Iterate through each item and process it accordingly
    for (const item of items) {
      const existingCartItemIndex = cartData.items.findIndex(
        (cartItem) => item.id === cartItem.id
      );

      let response;

      if (existingCartItemIndex >= 0) {
        // Update the quantity if the item is already in the cart
        const newQuantity = +item.quantity + +cartData.items[existingCartItemIndex].quantity;
        const quantityObj = {
          // Line IDs are strings per Shopify API documentation
          line: (existingCartItemIndex + 1).toString(),
          quantity: newQuantity,
        };
        response = await changeCartItems(quantityObj, items, ...variants);
      } else {
        // Add the item to the cart if it doesn't already exist
        response = await addItemsToCart([item], ...variants);
      }

      // Handle any potential error messages
      await handleResponseMessage(response, item.id, item.quantity);

      return response;
    }
  } catch (error) {
    console.error('Error in onAddToCart:', error);
  }
};


const afterAddToCart = async (items = [], ...variants) => {
  const event = {
    bubbles: true,
    detail: { variants, items },
  };

  await rerenderCartContent();
  switchCheckoutUrlOnRerender();
  document.dispatchEvent(new CustomEvent('cart:change', event));
};

export const sortCartBundleItems = (cartItems, cartItemsContainer) => {
  try {
    let cartItemsArr = Array.from(cartItems);
    if (!cartItemsArr.length) return;

    const bundleItems = [...cartItemsArr].filter((item, index) => {
      const isBundleItem =
        item.dataset.isDiscounted == 'true' &&
        item.dataset.isBundleItem == 'true';

      if (isBundleItem) {
        cartItemsArr = cartItemsArr.filter(
          (line) => line.dataset.index !== item.dataset.index
        );
      } else {
        item.classList.remove('cart-item--child');
      }

      return isBundleItem;
    });

    if (!bundleItems.length) return;

    const bundlesByParentId = {};
    bundleItems.forEach((item) => {
      const parentVariantId =
        item.dataset.bundleKey || item.dataset.parentBundleId;
      const maxBundleItemsCount = +item.dataset.bundleItemsCount;

      bundlesByParentId[parentVariantId] ||= {
        parentEl: null,
        items: [],
      };

      if (item.dataset.bundleKey) {
        bundlesByParentId[parentVariantId].parentEl = item;
      } else if (
        maxBundleItemsCount > bundlesByParentId[parentVariantId].items.length
      ) {
        bundlesByParentId[parentVariantId].items.push(item);
      } else {
        cartItemsArr.push(item);
      }
    });

    const virtualContainer = document.createElement('div');
    Object.values(bundlesByParentId).forEach((bundle) => {
      virtualContainer.appendChild(bundle.parentEl);
      bundle.items.forEach((el, index) => {
        virtualContainer.appendChild(el);
        if (index === bundle.items.length - 1) {
          el.classList.add('cart-item--last');
        }
      });
    });
    cartItemsArr.forEach((el) => virtualContainer.appendChild(el));
    cartItemsContainer.innerHTML = virtualContainer.innerHTML;
  } catch (er) {
    console.log('Error while sorting bundle items', er);
  }
};
